module.exports = __webpack_public_path__ + "img/Vin.251ef533.jpg";